/** draft option + ส่วนลดก่อนเพิ่มสินค้าเข้าโพสต์ */

export type PreAddOptionItem = {
  adminOptionDefinitionId: string;
  surchargeLak: number;
  isAutoAttach: boolean;
  requiresCustomerInput: boolean;
  sortOrder: number;
};

export type PreAddSessionOptionsDraft = {
  items: PreAddOptionItem[];
  discountPercent: number | null;
  discountFixedLak: number | null;
  /** true = คง draft หลัง add; false = ล้างหลัง add สำเร็จ */
  keepForNextAdds: boolean;
};

export function isPreAddDraftActive(
  draft: PreAddSessionOptionsDraft | null,
): boolean {
  if (!draft) return false;
  return (
    draft.items.length > 0 ||
    draft.discountPercent != null ||
    draft.discountFixedLak != null
  );
}

export function preAddDraftSelectedCount(
  draft: PreAddSessionOptionsDraft | null,
): number {
  return draft?.items.length ?? 0;
}

/** payload ส่งกับ POST session-products / bulk */
export function toPreAddApiPayload(draft: PreAddSessionOptionsDraft | null): {
  options?: PreAddOptionItem[];
  discountPercent?: number | null;
  discountFixedLak?: number | null;
} {
  if (!draft || !isPreAddDraftActive(draft)) return {};
  return {
    options: draft.items,
    discountPercent: draft.discountPercent,
    discountFixedLak: draft.discountFixedLak,
  };
}
